window.addEventListener("resize", function () {
  let windowWidth = window.innerWidth;
  if (windowWidth <= 400) {
    let slides = document.querySelectorAll('[id^="Slide-"]'); // Select slides by ID prefix
    let windowWidth = window.innerWidth;

    slides.forEach((slide) => {
      slide.style.marginRight = "60px"; // Remove right margin on small screens
      console.log("slide.style.marginRight", slide, slide.style.marginRight);
    });
  }
});
